{
  "name": "@secureonelab-site/app",
  "private": true,
  "version": "1.0.0",
  "type": "module",
  "scripts": {
    "dev": "../../node_modules/vite/bin/vite.js",
    "build": "../../node_modules/vite/bin/vite.js build --mode production",
    "preview": "../../node_modules/vite/bin/vite.js preview",
    "prerender": "node scripts/prerender.mjs",
    "verify-crawlable": "node scripts/verify-crawlable.mjs",
    "llms-full": "node scripts/llms-full.mjs",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "test": "npm run test:unit && npm run test:components",
    "test:unit": "../../node_modules/vitest/vitest.mjs run --config vitest.unit.config.js",
    "test:watch": "../../node_modules/vitest/vitest.mjs --config vitest.unit.config.js",
    "test:components": "../../node_modules/vitest/vitest.mjs run --config vitest.components.config.js",
    "test:components:watch": "../../node_modules/vitest/vitest.mjs --config vitest.components.config.js",
    "shutdown": "kill -9 `lsof -t -i:3000`",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "dependencies": {
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.0",
    "@fontsource/roboto": "^5.2.5",
    "@hookform/resolvers": "^5.0.1",
    "@mui/icons-material": "^7.1.1",
    "@mui/lab": "^7.0.0-beta.13",
    "@mui/material": "^7.1.1",
    "@mui/styled-engine-sc": "^7.1.1",
    "@mui/x-charts": "^8.5.1",
    "@mui/x-date-pickers": "^8.5.1",
    "@radix-ui/react-accordion": "^1.2.2",
    "@radix-ui/react-slot": "^1.1.1",
    "@radix-ui/react-tabs": "^1.1.2",
    "@react-google-maps/api": "^2.20.7",
    "@sentry-internal/replay": "9.47.1",
    "@sentry/react": "^9.27.0",
    "@tailwindcss/postcss": "^4.2.2",
    "@tailwindcss/vite": "^4.2.2",
    "@tanstack/react-query": "^5.90.5",
    "@tanstack/react-router": "^1.120.16",
    "axios": "^1.12.0",
    "class-variance-authority": "^0.7.1",
    "date-fns": "^4.1.0",
    "immer": "^11.1.4",
    "lodash": "^4.17.23",
    "lucide-react": "^0.577.0",
    "motion": "^12.38.0",
    "react": "^19.2.4",
    "react-dom": "^19.2.4",
    "react-hook-form": "^7.71.2",
    "react-intersection-observer": "^10.0.3",
    "react-phone-number-input": "^3.4.16",
    "styled-components": "^6.3.11",
    "tailwind-merge": "^3.5.0",
    "use-places-autocomplete": "^4.0.1",
    "yup": "^1.7.1"
  },
  "devDependencies": {
    "@babel/core": "^7.29.6",
    "@chromatic-com/storybook": "^5.0.1",
    "@eslint/js": "^9.39.4",
    "@mui/utils": "7.3.11",
    "@sentry/vite-plugin": "^5.1.1",
    "@storybook/addon-docs": "^10.3.0",
    "@storybook/addon-onboarding": "^10.3.0",
    "@storybook/react": "^10.3.0",
    "@storybook/react-vite": "^10.3.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@tanstack/eslint-plugin-query": "^5.91.5",
    "@tanstack/react-query-devtools": "^5.91.3",
    "@tanstack/react-router-devtools": "^1.166.9",
    "@tanstack/router-plugin": "^1.166.14",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@typescript-eslint/scope-manager": "8.59.2",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/browser": "^4.1.10",
    "@vitest/coverage-v8": "^4.1.10",
    "autoprefixer": "^10.4.27",
    "browserslist": "4.28.2",
    "caniuse-lite": "1.0.30001792",
    "diff": "9.0.0",
    "dom-helpers": "6.0.1",
    "es-abstract": "1.24.2",
    "eslint": "^9.39.4",
    "eslint-plugin-lube": "^0.5.1",
    "eslint-plugin-perfectionist": "^5.7.0",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.0.1",
    "eslint-plugin-react-refresh": "^0.5.2",
    "eslint-plugin-storybook": "^10.3.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.4.0",
    "jsdom": "^30.0.0",
    "lru-cache": "11.3.6",
    "ohash": "2.0.11",
    "playwright": "^1.58.2",
    "postcss": "^8.5.8",
    "prop-types": "^15.8.1",
    "rollup-plugin-visualizer": "^7.0.1",
    "storybook": "10.3.6",
    "tailwindcss": "^4.2.2",
    "typescript": "6.0.3",
    "vite": "8.1.0",
    "vite-plugin-compression2": "^2.0.1",
    "vitest": "^4.1.10",
    "zod": "3.25.76"
  },
  "eslintConfig": {
    "extends": [
      "plugin:storybook/recommended"
    ]
  }
}
